import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat)

import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');

dayjs.extend(utc)
dayjs.extend(timezone)

if(document.getElementById('app_UserSubscriptions') != null){

    document.addEventListener('alpine:init', () => {

        Alpine.data('app_UserSubscriptions', (route, route_utal, route_invoices, route_update_address) =>({
            userSubscriptions : [],
            subc : null,
            current_sub : null,
            invoices : [],
            displayAucuneFacture : false,
            modal_userSubscription : false,
            modal_userSubscription_utal : false,
            modal_userSubscription_utal_nom  : '',
            modal_userSubscription_utal_id : null,
            modal_userSubscription_error_msg : null,
            displayFormEditorAddress : false,
            route_update_address : null,
            isUniquePageSub : false,
            init(){
                this.route_utal = route_utal;
                this.route_invoices = route_invoices ?? null;
                this.refresh();

                if(this.route_invoices != null){
                    this.listInvoiceload();
                }

                this.route_update_address = route_update_address;

                setTimeout(() => {
                    this.modal_userSubscription_utal = false;
                },100)

                setTimeout(() => {
                    this.modal_userSubscription_utal = false;
                },500)
            },

            closeModal(){

                this.$nextTick(() => {
                    this.modal_userSubscription = false;

                })


            },
            openModal(id_sub){

                this.$nextTick(() => {
                    this.set_subc(id_sub);
                    this.$nextTick(() => {
                        this.modal_userSubscription = true;
                    })

                })

            },
            set_subc(id_sub){
                for (let i = 0; i < this.userSubscriptions.length; i++) {
                    if(this.userSubscriptions[i].id == id_sub){
                        this.subc = i;
                        this.$nextTick(() => {
                            this.current_sub = this.userSubscriptions[i];
                        })

                        console.log("position sub :"+i)
                        break;
                    }
                }


            },
            refresh(){
                this.userSubscriptions = [];
                axios({
                    method: 'get',
                    url: route,
                    data: {
                        filterStatus: 'active',
                      }
                }).then(response =>{

                    function compareUTAByDateEnd(utaA, utaB) {

                        // On met les demandes infinis en dernier
                        if (utaA.tarif__action.type === 'unlimited') {
                            return 1; // utaA à la fin de la liste
                        }
                        if (utaB.tarif__action.type === 'unlimited') {
                            return -1; // utaB à la fin de la liste
                        }

                        // On met les demandes utilisé compltement en dernier
                        if(utaA.quantity_used >= utaA.compteur){
                            return 1;
                        }

                        if(utaB.quantity_used >= utaB.compteur){
                            return -1;
                        }

                        const dateA = utaA.mDate_end.toDate(); // Convertir la date Day.js en objet Date
                        const dateB = utaB.mDate_end.toDate(); // Convertir la date Day.js en objet Date

                        // Utiliser la méthode compareTo de l'objet Date pour comparer les dates
                        return dateA.getTime() - dateB.getTime();
                    }

                    if(response.data.success){

                        for (let i = 0; i < response.data.userSubscriptions.length; i++) {
                            let sub = response.data.userSubscriptions[i];
                            for (let j = 0; j < sub.user_tarif_actions.length; j++) {
                                let UTA = sub.user_tarif_actions[j];

                                let mDate_start = dayjs.tz(UTA.date_start_action, 'Europe/Paris');
                                let mDate_end = dayjs.tz(UTA.date_end_action, 'Europe/Paris');
                                let mDate_now = dayjs().tz('Europe/Paris')

                                let mDate_start_local = mDate_start.local();
                                let mDate_end_local = mDate_end.local();

                                UTA['date_is_same_day'] = false;
                                UTA['date_is_same_day_time_left'] = false;
                                UTA['mDate_end'] = mDate_end;

                                if(mDate_start.isSame(mDate_end, 'day')){
                                    UTA['date_is_same_day'] = true;
                                    UTA['date_is_same_day_time_left'] = mDate_now.to(mDate_end, false);
                                }

                                UTA["date_start_action_beautiful"] = mDate_start.format('ll ');
                                UTA["date_end_action_beautiful"] = mDate_end.format('ll ');

                                UTA["date_start_action_beautiful_local"] = mDate_start_local.format('ll ');
                                UTA["date_end_action_beautiful_local"] = mDate_end_local.format('ll ');

                                if(mDate_now.isBetween(mDate_start, mDate_end, 'minute', '[]')){
                                    UTA['time_rang'] = 'now'; // les actions sont affichés
                                }else
                                if(mDate_now.isBefore(mDate_start)){

                                    UTA['time_rang'] = 'futur';
                                }else{
                                    UTA['time_rang'] = 'past';
                                }



                                // Afficher la description de L UTA
                                UTA['showDesc'] = false;
                                UTA['showDateFdlt'] = false;

                                // Gestion des UTAL

                                UTA['quantity_used'] = 0;
                                UTA['quantity_waiting'] = 0;
                                UTA['quantity_cancelled'] = 0;
                                UTA['display_transactions_waiting'] = false;
                                UTA['areButtonUtalDisabled'] = false;
                                for (let k = 0; k < UTA.utals.length; k++) {
                                    UTA.utals[k]._type="utals";
                                    if(UTA.utals[k].statut == 'done'){
                                        UTA['quantity_used'] += UTA.utals[k].action * -1;
                                    }
                                    if(UTA.utals[k].statut == 'waiting'){
                                        UTA['quantity_waiting'] += UTA.utals[k].action * -1;
                                        UTA['display_transactions_waiting'] = true;
                                    }
                                    if(UTA.utals[k].statut == 'cancelled'){
                                        UTA['quantity_cancelled'] += UTA.utals[k].action * -1;
                                    }


                                    let _created = dayjs(UTA.utals[k].created_at);
                                    let _update = dayjs(UTA.utals[k].updated_at);

                                    UTA.utals[k].created_at_beautiful  = _created.format('ll HH:mm');
                                    UTA.utals[k].updated_at_beautiful = _update.format('ll HH:mm');

                                    if(UTA.tarif__action.is_credit){
                                        UTA.utals[k].action_beautiful = (UTA.utals[k].action / 100).toFixed(2) + ''+window.currency_symbols[sub.tarif.currency.toUpperCase()]
                                    }else{
                                        UTA.utals[k].action_beautiful = UTA.utals[k].action ;
                                    }

                                }

                                for (let k = 0; k < UTA.utacs.length; k++) {
                                    UTA.utacs[k]._type="utacs";
                                    let _created = dayjs(UTA.utacs[k].created_at);
                                    let _update = dayjs(UTA.utacs[k].updated_at);

                                    UTA.utacs[k].created_at_beautiful  = _created.format('ll HH:mm');
                                    UTA.utacs[k].updated_at_beautiful = _update.format('ll HH:mm');

                                    if(UTA.tarif__action.is_credit){
                                        UTA.utacs[k].action_beautiful = (UTA.utacs[k].action / 100).toFixed(2) + ''+window.currency_symbols[sub.tarif.currency.toUpperCase()]
                                    }else{
                                        UTA.utacs[k].action_beautiful = UTA.utacs[k].action ;
                                    }

                                }

                                UTA['utals_utacs'] = UTA.utals.concat(UTA.utacs);

                                // Trie la liste en fonction de la date de création
                                UTA['utals_utacs'].sort((a, b) => {
                                    // Utilisez la bibliothèque dayjs pour parser les dates
                                    let dateA = dayjs(a.created_at);
                                    let dateB = dayjs(b.created_at);

                                    // Compare les dates
                                    return dateB  -  dateA;
                                });

                            }

                            sub.user_tarif_actions.sort(compareUTAByDateEnd);



                            sub.tab_active = 'now';

                            sub.s_created_at_beautiful = dayjs(sub.created_at).format('DD MMM YYYY');
                            // On est sur une page unique

                            if(sub.isUniquePageSub){
                                this.isUniquePageSub = true;
                                let sub_stripe = sub.stripe;

                                sub_stripe.current_period_start_beautiful = dayjs(sub_stripe.current_period_start * 1000).format('DD MMM YYYY');
                                sub_stripe.current_period_end_beautiful = dayjs(sub_stripe.current_period_end * 1000).format('DD MMM YYYY');
                                if(sub_stripe.cancel_at_period_end){
                                    sub_stripe.cancel_at_beautiful = dayjs(sub_stripe.cancel_at * 1000).format('DD MMM YYYY');
                                }

                                if(sub_stripe.canceled_at){
                                    sub_stripe.canceled_at_beautiful = dayjs(sub_stripe.canceled_at * 1000).format('DD MMM YYYY');
                                }

                            }

                            if(sub.product.is_address_needed){
                                if(typeof sub.invoices != 'undefined'){
                                    for (let kk = 0; kk < sub.invoices.length; kk++) {
                                        let mInvoice = sub.invoices[kk];
                                        if(mInvoice.invoice_customer_address){
                                            mInvoice.invoice_customer_address.updated_at_beautiful = dayjs(mInvoice.invoice_customer_address.updated_at).format('DD MMM ');
                                            if(window.validUrl.isUri(mInvoice.invoice_customer_address.tracking_number)){
                                                mInvoice.invoice_customer_address.tracking_number_url = mInvoice.invoice_customer_address.tracking_number;
                                            }else{
                                                mInvoice.invoice_customer_address.tracking_number_url = null;
                                            }
                                        }
                                        mInvoice.period_start = dayjs( mInvoice.period_start).format('DD MMM ');


                                    }
                                }

                            }

                        }

                        this.$nextTick(() => {
                            this.userSubscriptions = response.data.userSubscriptions;
                            this.isModalPayementSuccessNeeded();
                        })
                    }


                });
            },
            confirm_utiliser(id_uta_ta){
                console.log("utiliser "+this.route_utal);

                this.modal_userSubscription_utal_nom = '';
                this.modal_userSubscription_utal_id = null;

                for (let i = 0; i < this.userSubscriptions.length; i++) {
                    let sub = this.userSubscriptions[i];
                    for (let j = 0; j < sub.user_tarif_actions.length; j++) {
                        if(id_uta_ta == sub.user_tarif_actions[j].id){
                            this.modal_userSubscription_utal_id = sub.user_tarif_actions[j].id;
                            this.modal_userSubscription_utal_nom = sub.user_tarif_actions[j].tarif__action.nom;
                            this.modal_userSubscription_utal = true;
                        }
                    }
                }



            },
            cancel_confirm_utiliser(id_uta_ta){
                this.modal_userSubscription_utal = false;
                this.modal_userSubscription_utal_nom = '';
                this.modal_userSubscription_utal_id = null;
                this.modal_userSubscription_error_msg = null;
            },
            utiliser(tgt, id_uta_ta){
                console.log("utiliser "+this.modal_userSubscription_utal_id);
                tgt.disabled = true;
                axios.post(this.route_utal, {'id_uta_ta' : id_uta_ta, 'action' : -1},{

                }).then(response =>{

                    if(response.data.success){
                        for (let i = 0; i < this.userSubscriptions.length; i++) {
                            let sub = this.userSubscriptions[i];
                            for (let j = 0; j < sub.user_tarif_actions.length; j++) {
                                if(response.data.utal.id_user_tarif_action == sub.user_tarif_actions[j].id){

                                    this.$nextTick(() => {
                                        sub.user_tarif_actions[j]['utals'].push(response.data.utal);

                                        sub.user_tarif_actions[j]['quantity_used'] = 0;
                                        sub.user_tarif_actions[j]['quantity_waiting'] = 0;
                                        sub.user_tarif_actions[j]['quantity_cancelled'] = 0;
                                        for (let k = 0; k < sub.user_tarif_actions[j]['utals'].length; k++) {

                                            if(sub.user_tarif_actions[j]['utals'][k].statut == 'done'){
                                                sub.user_tarif_actions[j]['quantity_used'] += sub.user_tarif_actions[j]['utals'][k].action * -1;
                                            }
                                            if(sub.user_tarif_actions[j]['utals'][k].statut == 'waiting'){
                                                sub.user_tarif_actions[j]['quantity_waiting'] += sub.user_tarif_actions[j]['utals'][k].action * -1;
                                            }
                                            if(sub.user_tarif_actions[j]['utals'][k].statut == 'cancelled'){
                                                sub.user_tarif_actions[j]['quantity_cancelled'] += sub.user_tarif_actions[j]['utals'][k].action * -1;
                                            }
                                        }

                                        this.cancel_confirm_utiliser();
                                    })


                                }
                            }
                        }
                    }else{
                        this.modal_userSubscription_error_msg = response.data.error;
                    }
                    tgt.disabled = false;

                    console.log(response)
                });
            },
            waiting(){
                console.log('waiting');
                //document.getElementById('app_feed').dispatchEvent(new CustomEvent('refreshfeed', { detail: {}}))
            },
            row(){
                console.log('row');
            },
            listInvoiceload(){
                axios({
                    method: 'get',
                    url: this.route_invoices,
                }).then(response =>{

                    for (let i = 0; i <  response.data.invoices.length; i++) {
                        response.data.invoices[i]['period_start_readable']= dayjs(response.data.invoices[i]['period_start']).format('DD MMM YYYY');
                        response.data.invoices[i]['period_end_readable']= dayjs(response.data.invoices[i]['period_end']).format('DD MMM YYYY');
                        response.data.invoices[i]['created']= dayjs(response.data.invoices[i]['created']).format('DD MMM YYYY');
                    }

                    this.invoices = response.data.invoices;
                    if(this.invoices.length == 0){
                        this.displayAucuneFacture = true;
                    }else{

                    }
                });
            },
            cancelSubscriptionById(tgt,s_id, route_resiliation){

                tgt.disabled = true;

                console.log('cancel subscription' + s_id);

                axios.post(route_resiliation, {},{

                }).then(response =>{
                    console.log(response)
                    this.refresh()
                    tgt.disabled = false;
                    document.getElementById('modal-cancelsub').checked = false;
                });
            },
            modal_userSubscription_payementsuccess : false,
            modal_payement_success_is_recurrent : true,
            modal_userSubscription_payementsuccess_nom_pro : '',
            modal_userSubscription_payementsuccess_nom_plan : '',
            isModalPayementSuccessNeeded(){
                // Obtenez l'URL actuelle
                var currentURL = window.location.href;

                // Vérifiez si le hashtag est présent dans l'URL
                if (currentURL.includes("#payement-success")) {
                    this.open_payement_success_modal();
                }
            },
            open_payement_success_modal(){
                console.log("utiliser "+this.route_utal);

                this.modal_payement_success_is_recurrent = this.userSubscriptions[0].product.is_recurrent;
                this.modal_userSubscription_payementsuccess = true;

                this.modal_userSubscription_payementsuccess_nom_pro = this.userSubscriptions[0].product.pro.nom;
                this.modal_userSubscription_payementsuccess_nom_plan = this.userSubscriptions[0].name;
            },
            cancel_payement_success_modal(){
                this.modal_userSubscription_payementsuccess = false;
            },
            showalertbottom : false,
            handlenewaddressSuccess(defaultAddress){
                let ndefaultAddress = JSON.parse(JSON.stringify(defaultAddress));
                if(this.isUniquePageSub){
                    if(ndefaultAddress.id != null){
                        if(ndefaultAddress.id != this.userSubscriptions[0].customer_address.id){
                            axios.post(this.route_update_address+"/"+ndefaultAddress.id, {},{}).then(response =>{
                                if(response.data.success){
                                    this.userSubscriptions[0].customer_address = response.data.defaultAddress;
                                    this.displayFormEditorAddress = false;
                                    this.showalertbottom = true;
                                    this.to_alert_botton = setTimeout(  () => {
                                        this.showalertbottom = false
                                    }, 3000);
                                }

                            }).catch(thrown =>{

                            });
                        }else{
                            this.userSubscriptions[0].customer_address = ndefaultAddress;
                        }

                    }
                }

            },
        }))
    })

}
